// src/components/DeleteContactButton.jsx
import React from "react";
import { Button } from "@mui/material";

const DeleteContactButton = ({ onDelete, id, isMobile, t, sondageVerrouille }) => (
  <Button
    className="delete-button"
    onClick={() => {
      if (!sondageVerrouille) onDelete(id);
    }}
    size={isMobile ? "small" : "medium"}
    variant="text"
    disabled={sondageVerrouille} // ✅ désactive le bouton
    sx={{
      minWidth: isMobile ? "auto" : "80px",
      paddingX: isMobile ? 0.5 : 1,
      fontSize: isMobile ? "0.7rem" : "0.85rem",
      alignItems: "center",
      width: "100%",
      color: sondageVerrouille ? "#aaa" : "#d32f2f", // ✅ couleur grisée
      "&.Mui-disabled": {
      color: "#aaa !important"
    }
    }}
  >
    {isMobile ? "❌" : t('Del')}
  </Button>
);

export default DeleteContactButton;
